import { title as connectTitle } from './AddTrustooKoppeling';
import { WizardFlow } from '~/graphql/types.client';
import {
  title as GenericWidgetAppSelectionTitle,
  id as GenericWidgetAppSelectionId,
} from '../../GenericSteps/GenericWidgetAppSelection';
import { StepId } from '../..';

const typename = 'AppStatus_Trustoo';
const trustooEnablementFlow: WizardFlow = {
  id: 'enable-trustoo',
  steps: [
    {
      title: GenericWidgetAppSelectionTitle,
      id: GenericWidgetAppSelectionId as StepId,
      metadata: { typename },
    },
    {
      title: connectTitle,
      id: 'AddTrustooKoppeling',
      metadata: { typename },
    },
  ],
};

export default trustooEnablementFlow;
